import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    btnSearch,
    onExport
    
} from '../../store/fuerzaventas/preciostock/actions';

import { Body, Footer, Page } from '@sigeco/tools';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';

//import ListarProductosFilter from '../../components/fuerzaventas/listarproductos/ListarProductosFilter';
//import ListarProductosList from '../../components/fuerzaventas/listarproductos/ListarProductosList';
import PrecioStockList from '../../components/fuerzaventas/preciostock/PrecioStockList';
import PrecioStockFilter from '../../components/fuerzaventas/preciostock/PrecioStockFilter';



///CAMBIAR LOS IMPORTS

const PrecioStock = ({onClose, setTitle}) => {
    const loading = useSelector(state => state.preciostock.loading);
    const dispatch = useDispatch();
    
    useEffect(() => {
        setTitle('Búsqueda');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        onClose();
    }

    return (
        <Page>
            <Backdrop style={{ position: 'absolute', zIndex: 1200 }} open={loading} transitionDuration={0}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Body>
                <PrecioStockFilter />
                <PrecioStockList />
            </Body>
            <Footer>
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(onExport())}
                    startIcon={<Icon className="fas fa-file-excel"/>}
                  >
                    Exportar
                </Button>
              
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(btnSearch())}
                    startIcon={<Icon className="fas fa-search"/>}
                >
                    Buscar
                </Button>
                <Button 
                    color="primary" 
                    size="small" 
                    variant="outlined" 
                    onClick={() => onBtnClose()} 
                    startIcon={<Icon className="fas fa-door-open"/>}
                >
                    Salir
                </Button>
            </Footer>
        </Page>
    )
};

export default PrecioStock;